import * as React from 'react';
import * as styles from './styles.css';

import cn from 'clsx';

import { ArticleHeading2, ArticleParagraph1, Image } from '@cian/ui-kit';

export interface IAgentAsideCardProps {
  name: string;
  experience: string;
  avatarUrl: string;
  footer?: React.ReactNode;
  sticky?: boolean;
  honest?: React.ReactNode;
  documentsChecked?: React.ReactNode;
}

export const AgentAsideCard = ({
  name,
  experience,
  avatarUrl,
  footer,
  sticky,
  honest,
  documentsChecked,
}: IAgentAsideCardProps) => {
  return (
    <div data-testid="AgentAsideCard" className={cn(styles['card'], sticky && styles['card--sticky'])}>
      <div className={styles['info']}>
        <div className={styles['about']}>
          <div className={styles['name']}>
            <ArticleHeading2 color="text-primary-default">
              {name} {honest}
            </ArticleHeading2>
          </div>
          <ArticleParagraph1 color="text-primary-default">{experience}</ArticleParagraph1>
          {documentsChecked}
        </div>
        <div className={styles['avatar']}>
          <Image src={avatarUrl} alt="Аватар" title={name} borderRadius="50%" width={90} height={90} />
        </div>
      </div>
      {footer && <div className={styles['footer']}>{footer}</div>}
    </div>
  );
};
